/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { ListItem, ListItemButton, ListItemIcon, Typography } from "@mui/material";
import { Link, useLocation } from "react-router";
import Icon from "@/src/components/Icon/Icon";
import { FC } from "react";
import { IconRenderProps } from "@/src/types/IconRenderProps";
import { SvgIconComponent } from "@mui/icons-material";
import { mergeSx } from "@/src/utils/mergeSx";
import { authenticatedNavigationStyle } from "@/src/components/Navigation/AuthenticatedNavigation/authenticatedNavigationStyle";
import { useTheme } from "@mui/material/styles";

export type AuthenticatedNavigationLinkDefaultProps = (
  | {
      type: "customIcon";
      icon: FC<IconRenderProps>;
    }
  | {
      type: "muiIcon";
      icon: SvgIconComponent;
    }
) & {
  label: string;
  to: string;
};

export default function AuthenticatedNavigationLinkDefault({ to, type, label, icon: IconComp }: AuthenticatedNavigationLinkDefaultProps) {
  const theme = useTheme();
  const location = useLocation();

  return (
    <ListItem disableGutters disablePadding>
      <ListItemButton
        component={Link}
        to={to}
        sx={mergeSx(authenticatedNavigationStyle.link, location.pathname === to && authenticatedNavigationStyle.linkActive, { margin: "0.25rem 0" })}
      >
        <ListItemIcon sx={{ marginRight: "0.5rem" }}>
          {type === "customIcon" ? <Icon icon={IconComp} fill={theme.palette.common.black} /> : <IconComp sx={{ color: theme.palette.common.black }} />}
        </ListItemIcon>
        <Typography component={"span"} variant={"h7"}>
          {label}
        </Typography>
      </ListItemButton>
    </ListItem>
  );
}
